module.exports = __webpack_public_path__ + "static/img/T7404_address.d75d0212.png";